"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Box_1 = require("@material-ui/core/Box");
var core_1 = require("@material-ui/core");
var enquiryFormTitleStyles_1 = require("./enquiryFormTitleStyles");
var EnquiryFormTitle = function (_a) {
    var title = _a.title;
    var styles = enquiryFormTitleStyles_1.default();
    return (<Box_1.default className={styles.title}>
      <core_1.Typography component={'h2'} variant={'h5'} data-test="enquiry_form:title" className={styles.titleContent}>
        {title}
      </core_1.Typography>
    </Box_1.default>);
};
exports.default = EnquiryFormTitle;
